import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { LoadingSpinner } from '../';
import { mapCreatorConnect } from '../../higher-order-components';

class MapEditWarningModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleKeyDown(e) {
    if(e.key == 'Enter') {
      this.props.onConfirm();
    }
  }

  componentDidUpdate() {
    const { show_edit_warning_modal } = this.props.mapCreator;
    if(show_edit_warning_modal == true) {
      $(document).on('keydown', this.handleKeyDown);
    }
    else if(show_edit_warning_modal == false) {
      $(document).off('keydown', this.handleKeyDown);
    }
  }

  render() {
    const { show_edit_warning_modal } = this.props.mapCreator;
    return (
      <Modal
        show={show_edit_warning_modal}
        onHide={() => this.props.toggleShowEditMapWarningModall(false)}
        bsSize='sm'
        >
        <div className={`panel panel-warning mb-none`}>
          <div className='panel-heading'>
            <h4>Warning!</h4>
          </div>
          <Modal.Body>
            {this.props.fetching ?
            <LoadingSpinner size={3}/> :
            <div>
              <p>
                This action will cause the map's status to become "Unfinished".
                Please re-check the "Finished" switch if you make any edits to this map.
              </p>
              <div className='row mt-md'>
                <div className='col-xs-6 col-md-6'>
                  <div
                    className='btn btn-block btn-default'
                    onClick={this.props.cancelEditMapWarning}
                    >
                    Cancel
                  </div>
                </div>
                <div className='col-xs-6 col-md-6'>
                  <div
                    className='btn btn-block btn-warning'
                    onClick={this.props.confirmEditMapWarning}
                    >
                    Got It
                  </div>
                </div>
              </div>
            </div>}
          </Modal.Body>
        </div>
      </Modal>
    )
  }
}

export default mapCreatorConnect(MapEditWarningModal);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-edit-warning-modal.js